export default {
      id: "mobile-usage",
      viewBox: "0 0 13 22",
      url: __webpack_public_path__ + "img/icons.df848786.svg#mobile",
      toString: function () {
        return this.url;
      }
    }